"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "usePhoneNumberLocalization", {
    enumerable: true,
    get: function() {
        return usePhoneNumberLocalization;
    }
});
const _react = require("react");
const _localisationeq1 = require("@equiem/localisation-eq1");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const LOADING = {
    ready: false,
    localization: undefined
};
const getStrings = async (language)=>{
    switch(language.split(/-_/u)[0]){
        case "de":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/de.json")));
        case "es":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/es.json")));
        case "fr":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/fr.json")));
        case "pl":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/pl.json")));
        case "hu":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/hu.json")));
        case "ja":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/jp.json")));
        // unsupported, fall back to English:
        case "nl":
            return Promise.resolve(undefined);
        case "sk":
            return Promise.resolve(undefined);
        case "cs":
            return Promise.resolve(undefined);
        // not in use by us, but available in the library:
        case "ru":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/ru.json")));
        case "cn":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/cn.json")));
        case "pt":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/pt.json")));
        case "it":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/it.json")));
        case "ir":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/ir.json")));
        case "ar":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/ar.json")));
        case "tr":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/tr.json")));
        case "id":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/id.json")));
        case "ko":
            return Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("react-phone-input-2/lang/ko.json")));
        case "en":
        default:
            return Promise.resolve(undefined);
    }
};
const usePhoneNumberLocalization = ()=>{
    const { i18n } = (0, _localisationeq1.useTranslation)();
    const [locale, setLocale] = (0, _react.useState)(LOADING);
    const [hasRenderedSinceLocaleChange, setHasRenderedSinceLocaleChange] = (0, _react.useState)(true);
    (0, _react.useEffect)(()=>{
        let active = true;
        setLocale(LOADING);
        setHasRenderedSinceLocaleChange(false);
        getStrings(i18n.language).then((newStrings)=>{
            if (active) {
                setLocale({
                    ready: true,
                    localization: newStrings
                });
            }
        }).catch((e)=>{
            // eslint-disable-next-line no-console
            console.error(e);
            if (active) {
                setLocale({
                    ready: true,
                    localization: undefined
                });
            }
        });
        return ()=>{
            active = false;
        };
    }, [
        i18n.language
    ]);
    (0, _react.useEffect)(()=>{
        if (!hasRenderedSinceLocaleChange) {
            setHasRenderedSinceLocaleChange(true);
        }
    }, [
        hasRenderedSinceLocaleChange
    ]);
    return hasRenderedSinceLocaleChange ? locale : LOADING;
};

//# sourceMappingURL=usePhoneNumberLocalization.js.map